
<div class="main">
    <div class="wrapper">
      <div class="global-head-column">
        <div class="global-head-row">
          <div class="page-title">GENERAL SETTINGS</div>
        </div>
      </div>
      <div class="scroll-wrapper">
        <p-table
          #dtc
          [columns]="cols"
          dataKey="type"
          [value]="tableData$() | async"
          [scrollable]="true"
          [scrollHeight]="getScrollHeight()"
        >
          <ng-template pTemplate="header" let-columns>
            <th
              *ngFor="let col of columns"
              [class.col--typeName]="col.field == 'settingTypeName'"
              [class.col--settingValue]="
                col.field == 'settingValue'
              "
            >
              <div class="status-flex">
                <div
                  class="horizontal-flex"
                  *ngIf="!checkSortIcon(col.field); else filterHeader"
                >
                  {{ col.header }}
                </div>
                <ng-template #filterHeader>
                  <div
                    class="horizontal-flex clickable"
                    [matMenuTriggerFor]="extendedFilter"
                    #menuTrigger="matMenuTrigger"
                  >
                    {{ col.header }}
                    <ng-container
                      *ngIf="{
                        direction: (getFieldSort$(col.field) | async)
                      } as sort"
                    >
                      <mat-icon
                        class="sortIcon {{
                          sort.direction == 1
                            ? 'sort-ascending'
                            : 'sort-descending'
                        }}"
                        *ngIf="sort.direction"
                        >straight</mat-icon
                      >
                    </ng-container>
                    <mat-icon class="material-icons-outlined sortIcon"
                      >filter_alt</mat-icon
                    >
                    <ng-container
                      *ngIf="getFieldFilters$(col.field) | async as filters"
                    >
                      <span *ngIf="filters" class="clear-header-filters"
                        >({{ filters.length }})</span
                      >
                    </ng-container>
                  </div>
                  <mat-menu
                    class="column-filter-menu"
                    #extendedFilter="matMenu"
                    [hasBackdrop]="true"
                  >
                    <app-column-filter
                      *ngIf="menuTrigger.menuOpen"
                      [values]="getFieldValues$(col.field) | async"
                      [template]="getFieldTemplate(col.field)"
                      [canSearch]="getFieldFilterSearch(col.field)"
                      [hasEmptyValue]="getFieldHasEmptyValue(col.field)"
                      [initialSelected]="getFieldFilters$(col.field) | async"
                      [initialSort]="getFieldSort$(col.field) | async"
                      [ignoredValues]="col.ignoredFilterValues"
                      (sort)="setSort(col.field, $event)"
                      (filter)="setFilter(col.field, $event)"
                      (closePopup)="menuTrigger.closeMenu()"
                    ></app-column-filter>
                  </mat-menu>
                </ng-template>
              </div>
            </th>
            <th class="col--actions">
              <div class="clear-button">
                <button
                  class="clear-button"
                  mat-flat-button
                  color="warn"
                  (click)="clearAllFilter()"
                  *ngIf="extendedFilterActive$ | async"
                >
                  clear all
                </button>
              </div>
            </th>
          </ng-template>
          <ng-template pTemplate="body" let-setting>
            <tr [pEditableRow]="setting">
              <td class="col--typeName">
                {{ getSettingTypeName(setting.settingType) }}
              </td>                    
              <td class="col--settingValue">
                <div style="display: flex; flex-direction: row">
                    <ng-container *ngIf="setting.settingDataType === 'boolean'; else stringInput">
                        <p-inputSwitch
                          (onChange)="changeGeneralSetting(setting)"
                          [(ngModel)]="setting.settingBoolValue"
                        ></p-inputSwitch>
                      </ng-container>
                      <ng-template #stringInput>
                        <input
                          type="text"
                          [(ngModel)]="setting.settingValue"
                          (change)="changeGeneralSetting(setting)"
                        >
                      </ng-template>
                  <div
                    *ngIf="canShowStateInfo(setting)"
                    style="padding-left: 10px"
                  >
                    <mat-icon
                      *ngIf="setting && setting.state == saveStates.ongoing"
                      >autorenew</mat-icon
                    >
                    <mat-icon
                      class="red-icon"
                      *ngIf="setting && setting.state == saveStates.failed"
                      >autorenew</mat-icon
                    >
                    <mat-icon
                      class="green-icon"
                      *ngIf="setting && setting.state == saveStates.done"
                      >done</mat-icon
                    >
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>